export const getUrl = () => {
  const urldata = localStorage.getItem("urlData");
  if (urldata) return JSON.parse(urldata);
  else return null;
};

export const setUserData = (user) => {
  localStorage.setItem('userDt', JSON.stringify(user));
};

export const getUserData = () => {
  const userdata = localStorage.getItem("userDt");
  if (userdata) return JSON.parse(userdata);
  else return null;
};

export const removeUserSession = () => {
  localStorage.removeItem("urlData");
  localStorage.removeItem("userDt");
  localStorage.removeItem("userKey");
}